import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import taxation_img1 from "../../assets/images/contents/taxation_1.png"
import taxation_img2 from "../../assets/images/contents/taxation_2.svg"
import { PrimaryButton } from '../../components/StyledButtons'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const Taxation = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
  const modalDiscussionRef = useRef(null);
  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false)
    }
  };
  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
    }
  };

  return (
    <div className='taxation bg-primary'>
      <div className='color-filter-right' style={{ top: "20%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "52%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid taxation-header pb-100'>
        <div className='container'>

          {language === "en" ?
            <div className='col-sm-12 pt-150'>
              <div className='font-weight-bold text-center font-64 taxation-header-title'>Taxation, Revenue & Customs</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
            :
            <div className='col-sm-10 col-sm-offset-1 pt-150'>
              <div className='font-weight-bold text-center font-64 taxation-header-title'>Thuế, Doanh thu & Hải quan</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
          }
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.taxation')} linkToPrevPage="/industries" />
          </div>
        </div>


      </div>
      <div className='taxation-content container'>
        <div className='row flex-lg'>
          <div className='col-lg-w-400'>
            <IndustriesStickyMenu governmentActive={true} taxationActive={true} />
          </div>
          <div className='col-lg-w--400 taxation-content_info'>
            <p className='font-48 font-weight-semibold text-white'>{t('taxation.title')}</p>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('taxation.sub-title-1')}</p>
            <div className='pt-50'>
              <img src={taxation_img1} alt="" className='img-responsive' />
            </div>
            <p className='text-white pt-50'>{t('taxation.content-1')}</p>
            <p className='text-white pt-20'>{t('taxation.content-2')}</p>
            <p className='text-white pt-20'>{t('taxation.content-3')}</p>
            <div style={{overflowX:"auto"}} className='pt-20'>
              <table>
                <thead>
                  <tr>
                    <th>{t('taxation.table.customs-receipts')}</th>
                    <th>{t('taxation.table.income-tax-assessments')}</th>
                    <th>{t('taxation.table.gst-receipts')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('taxation.table.certificate-of-residency')}</td>
                    <td>{t('taxation.table.excise-duty-challans')}</td>
                    <td>{t('taxation.table.stamp-duty-receipts')}</td>
                  </tr>
                  <tr>
                    <td>{t('taxation.table.attestation-receipt')}</td>
                    <td>{t('taxation.table.import-license-receipt')}</td>
                    <td>{t('taxation.table.export-license-receipt')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('taxation.sub-title-2')}</p>
            <p className='text-white pt-20'>{t('taxation.content-4')}</p>
            <div className='pt-50'>
              <img src={taxation_img2} alt="" className='img-responsive' />
            </div>
            <div className='col-sm-12 pt-30 px-0'>
              <ul className='list-unstyled pt-20'>
                <li className='checked-line'>{t('taxation.content-5-1')}</li>
                <li className='checked-line'>{t('taxation.content-5-2')}</li>
                <li className='checked-line'>{t('taxation.content-5-3')}</li>
                <li className='checked-line'>{t('taxation.content-5-4')}</li>
                
              </ul>
            </div>
            <div className='col-sm-12 pt-30'>
              <div className='row'>
                <PrimaryButton
                onClick={() => setModalDiscussionOpen(true)}
                >{t('button.schedule-discussion')}</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <IndustriesImageContainer />
      </div>

      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm
        setOpenModal={setModalDiscussionOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default Taxation